<template>   
<el-dialog     :visible.sync="dialogVisible"     width="800px"     custom-class="public-dialog-class"     :close-on-click-modal="false"     :close-on-press-escape="false"     :show-close="true"     @close="cancel"     append-to-body   >     
<div class="dialog-header">       <img src="@/assets/images/my/dot.svg" alt="" />     
</div>     
<div slot="title" class="title">       
<div class="idea-title">         <i class="iconfont icon-note" />         在线反馈       
</div>     
</div>      
<div class="dialog-form">       
<el-form         :model="ruleForm"         :rules="rules"         ref="ruleForm"         label-width="100px"         class="demo-ruleForm"       >         
<el-form-item label="问题描述: " prop="description">           
<el-input autoId="input_ruleForm_description"             type="textarea"             v-model="ruleForm.description"             placeholder="请您详细说明遇到的情况和申请原因，以保证管理员及时准确判断并处理您的反馈。若信息不全或不明确，管理员将很难做出判断。500个汉字以内"             class="wd576"             rows="7"             maxlength="500"             resize="none"             show-word-limit           > 
</el-input>         
</el-form-item>         
<el-form-item label="截图: " prop="picturePath">           
<el-upload             ref="upload"             class="avatar-uploader"             :action="action"             accept=".jpg,.png,.jpeg,.bmp,.gif"             :limit="3"             :show-file-list="true"             :on-error="uploadError"             :on-exceed="onExceed"             :on-remove="onRemove"             :before-remove="handleRemove"             :on-preview="handlePictureCardPreview"             :on-success="handleAvatarSuccess"             :before-upload="beforeAvatarUpload"             list-type="picture-card"           >             <i slot="default" class="el-icon-plus"></i>             
<div slot="tip" class="el-upload__tip">               建议图片格式为：JPEG/BMP/PNG/GIF，大小不超过5M，最多可上传3张             
</div>           
</el-upload>         
</el-form-item>         
<el-form-item label="联系邮箱: " prop="email">           
<el-input autoId="input_ruleForm_email"             v-model="ruleForm.email"             placeholder="请输入"             maxlength="50"             size="small"             class="wd200"           > 
</el-input>         
</el-form-item>       
</el-form>     
</div>     <template #footer>       <span class="dialog-footer">         
<el-button autoId="btn_cancel" @click="cancel">取 消 
</el-button>         
<el-button autoId="btn_confirm" :loading="loading" type="primary" @click="confirm"           >提 交 
</el-button         >       </span>     </template>     
<el-dialog :visible.sync="imgVisible" custom-class="public-dialog-class">       <img width="100%" :src="dialogImageUrl" alt="" />     
</el-dialog>   
</el-dialog> </template>

<script>
import { feedbackAdd } from "@/api/my/my";
/** 在线反馈 */
export default {
  data() {
    return {
      /** 弹窗模态框 */
      dialogVisible: false,
      /** 大图模态框 */
      imgVisible: false,
      /** 大图图片 */
      dialogImageUrl: "",
      loading: false,
      /** 上传地址 */
      action: process.env.VUE_APP_BASE_API + "/resource/upload",
      ruleForm: {
        description: "",
        picturePath: [],
        email: "",
      },
      rules: {
        description: [
          {
            required: true,
            tigger: ["blur", "change"],
            message: "请输入问题描述",
          },
        ],
        picturePath: [
          {
            required: false,
            type: "array",
            trigger: "change",
            message: "请上传截图",
          },
        ],
        email: [
          {
            required: false,
            type: "email",
            tigger: ["blur", "change"],
            message: "请输入正确的邮箱",
          },
        ],
      },
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
      this.$refs.upload.clearFiles();
      this.resetForm("ruleForm");
    },
    confirm() {
      this.loading = true;
      this.$refs.ruleForm.validate((val) => {
        if (val) {
          const params = {
            ...this.ruleForm,
            source: this.$store.state.user.platform,
          };
          params.picturePath = params.picturePath.join(",");
          feedbackAdd(params)
            .then((res) => {
              if (res && res.code === 200) {
                this.$message.success("提交成功");
                this.cancel();
                this.$emit("success");
              }
            })
            .finally(() => {
              this.loading = false;
            });
          return;
        }
        this.loading = false;
      });
    },
    /** 成功上传的回调 */
    handleAvatarSuccess(response) {
      this.ruleForm.picturePath.push(response);
      this.$refs.ruleForm.validateField("picturePath");
    },
    uploadError(err) {
      console.log(err);
    },
    /** 上传之前的拦截 */
    beforeAvatarUpload(file) {
      const isJPG = [
        "image/jpeg",
        "image/gif",
        "image/png",
        "image/bmp",
      ].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPEG/BMP/PNG/GIF 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return false;
      }
      return isJPG && isLt2M;
    },
    /** 限制提示 */
    onExceed() {
      this.$message.error("最多可上传3张图片!");
    },
    /** 删除提示,仅提示 */
    handleRemove(file) {
      if (file && file.status === "success") {
        return new Promise((resolve, reject) => {
          this.$confirm("确定删除该图片?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              reject(false);
            });
        });
      }
    },
    /** 删除后去除数据 */
    onRemove(file) {
      if (file && file.status === "success") {
        const i = this.ruleForm.picturePath.findIndex(
          (el) => el === file.response
        );
        this.ruleForm.picturePath.splice(i, 1);
      }
    },
    /** 图片放大 */
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      //this.imgVisible = true;
      this.$nextTick(() => {
        this.$previewImage({
          multiple: true,
          imgList: [file.url]
        })
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-header {
  display: flex;
  opacity: 0;
  padding-right: 12px;
  justify-content: flex-end;
  // height: 24px;
  height: 12px;
  border-bottom: 1px solid var(--lineColor);
  img {
    width: 40px;
  }
}
.dialog-title {
  padding: 12px 36px;
  color: #3e4d71;
  font-size: 18px;
  font-weight: 500;
  .icon-bg {
    display: inline-block;
    margin-right: 4px;
    width: 32px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    background: #eef3ff;
    border-radius: 50%;
  }
  i {
    font-size: 16px;
    color: #5584fb;
  }
}
.dialog-form {
  padding: 28px 36px 38px;
  .form-font {
    color: #b9becc;
    font-size: 12px;
    font-weight: 400;
  }
}
.wd200 {
  width: 200px;
}
.wd320 {
  width: 320px;
}
.wd576 {
  width: 576px;
}
.el-form-item {
  margin-bottom: 22px;
}
:deep(.el-dialog__header) {
  padding: 0;
}
:deep(.el-dialog__body) {
  padding: 0;
}
:deep(.avatar-uploader) {
  display: flex;
  align-items: flex-end;
  .el-upload__tip {
    max-width: 320px;
    margin-left: 7px;
    line-height: 16px;
    color: #b9becc;
    font-size: 12px;
  }
  .el-upload {
    background: white;
  }
}
:deep(.el-icon-close-tip),
:deep(.el-upload-list__item-status-label) {
  display: none !important;
}
:deep(.avatar-uploader .el-upload) {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
:deep(.el-upload--picture-card) {
  display: inline-block;
  font-size: 28px;
  color: #8c939d;
  width: 64px;
  height: 64px;
  line-height: 64px;
  text-align: center;
}
:deep(.el-upload-list) {
  display: flex;
  height: 64px;
}
:deep(.el-upload-list__item) {
  width: 64px;
  height: 64px;
}
.avatar {
  width: 64px;
  height: 64px;
  display: block;
}
</style>
